import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AreaItemFormComponent } from '../area-item-form/area-item-form.component';
import { AreaItemService } from '../services/area-item.service';
import { MatSnackBar } from '@angular/material/snack-bar';


@Component({
    selector: 'app-area-item',
    templateUrl: './area-item.component.html',
    styleUrls: ['./area-item.component.css'],
    standalone: false
})
export class AreaItemComponent implements OnInit {

  //it contains the item of each area
  @Input() areaId: string; //it receives the information from
  //areaDoc: AngularFirestoreDocument<Area>;
  listOfItems$: Observable<any[]>

  constructor(
    private route: ActivatedRoute,
    private areaItemService: AreaItemService,
    private matSnackBar: MatSnackBar,
    //private db: AngularFirestore,
    private matDialog: MatDialog) { }

  ngOnInit() {
    this.showItems();
  }

  showItems() {
    let reportId = this.route.snapshot.params['repId'];
    let secId = this.route.snapshot.params['secId'];

    this.listOfItems$ = this.areaItemService.readAllByAreaId(secId, reportId, this.areaId);

    //Versión anterior
    // this.areaDoc = this.db.doc<Area>('sections/' + secId + '/templates/' + reportId + '/areas/' + this.areaId);

    // this.listOfItems$ = this.areaDoc.collection<AreaItem>('items', ref => {
    //   return ref.orderBy("date", "asc")
    // }).snapshotChanges()
    // .pipe(
    //   map(actions => {
    //     return actions.map(a => {
    //         const data = a.payload.doc.data() as AreaItem
    //         const id = a.payload.doc.id;
    //         return { id, data }
    //     })
    //   })
    // )

  }

  updateItem(areaItemId) {

    let reportId = this.route.snapshot.params['repId'];
    let secId = this.route.snapshot.params['secId'];

    let dialogRef = this.matDialog.open(AreaItemFormComponent, {
      width: '600px',
      data: { reportId: reportId, areaId: this.areaId, sectionId: secId, areaItemId: areaItemId}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log("after closed event");
    });

  }

  async deleteItem(areaItemId) {

    let reportId = this.route.snapshot.params['repId'];
    let secId = this.route.snapshot.params['secId'];

    if (confirm('¿Está seguro de eliminar el item?'))
    {
      await this.areaItemService.deleteAsync(secId, reportId, this.areaId, areaItemId);
       this.matSnackBar.open('Se eliminó con éxito', "Close", {
            verticalPosition: "bottom",
            duration: 3000,
          });
      // this.db.doc<AreaItem>('sections/' + secId + '/templates/' + reportId + '/areas/' + this.areaId + '/items/' + areaItemId)
      // .delete()
      // .then(a => {
      //   alert('El item se eliminó con éxito');
      // })
    }
  }

}
